import { IGameSessionPromotionInterface, PromotionLogic } from '@gongxigames/framework/promotions';

export class GameSessionPromotionLogic extends PromotionLogic<IGameSessionPromotionInterface> {}
